import { getOperatingSystem } from "./useDeviceDetection";

// Only these answer the universal link; the rest get the bankid:// scheme.
const opensUniversalLink = () =>
  ["iOS", "Android"].includes(getOperatingSystem());

// Keeps the current path and search so BankID returns to the page that started the
// flow with its params intact (/app-webview is only itself with ?webview).
const returnUrl = (nonce?: string | null) =>
  `${window.location.origin}${window.location.pathname}${window.location.search}${nonce ? `#nonce=${nonce}` : ""}`;

export const buildBankIdUrl = ({
  autoStartToken,
  nonce,
  inApp = false,
}: {
  autoStartToken?: string;
  nonce?: string | null;
  inApp?: boolean;
}) => {
  if (!autoStartToken) return undefined;

  if (!opensUniversalLink()) {
    return `bankid:///?autostarttoken=${autoStartToken}`;
  }

  // A redirect out of the app lands in the phone browser, which has none of the
  // webview's session. Sending nobody back leaves the still-polling view to finish.
  const redirect = inApp ? "null" : encodeURIComponent(returnUrl(nonce));
  return `https://app.bankid.com/?autostarttoken=${autoStartToken}&redirect=${redirect}`;
};

export const openBankId = (url: string) => {
  if (opensUniversalLink()) {
    // BankID requires an anchor element with referrerPolicy="origin" on mobile browsers
    const link = document.createElement("a");
    link.href = url;
    link.referrerPolicy = "origin";
    link.click();
    return;
  }
  window.location.href = url;
};
